module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/102/assets/images/e0d2c41f459e3cbc649c428dcefffcb6.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_bolt.svg
// module id = vvfS
// module chunks = 0